import React from "react";
import { Text } from "../../text";
import { defaultStyles } from "../../../../constants/style-constants/utils";
import Modal from "../modal";
import { Button } from "../../button";
import * as Style from "./styles/update-modal";
import { Icon } from "antd";
import { InputGroup } from "../../input/styles/input";
import { Input, InputGroupFlex, IconContainer } from "../../../styled-components/input/styles/inputTax";


function IconInputTaxNew(props) {
  const {
    onChange,
    name,
    style,
    iconPosition,
    iconType,
    icon,
    placeholder,
    value,
    updatedObject,
  } = props.value || props;

  const { index, obj } = props;
  return (
    <>
      <InputGroupFlex>
        {iconPosition === "start" ? (
          iconType ? (
            <IconContainer>
              <Icon type="phone" />
            </IconContainer>
          ) : (
            <IconContainer>
              <div>{icon}</div>
            </IconContainer>
          )
        ) : null}
        <Input
          style={style}
          disabled={updatedObject && updatedObject["unknownDollarValue"]  }
          onChange={(event) => {
            const inputValue = event.target.value;

            // Allow only numbers with up to two decimal places
            const regex = /^\d*\.?\d{0,2}$/;

            if (regex.test(inputValue)) {
              if (obj === "nestedObj") {
                onChange(index, event.target);
              } else {
                onChange(event);
              }
            }
          }}
          name={name}
          placeholder={placeholder}
          value={value}
        />
        {/* {iconPosition === "end" ? (
          <IconContainer>
            <Icon type="phone" />
          </IconContainer>
        ) : null} */}

        {iconPosition === "end" ? (
          iconType ? (
            <IconContainer>
              <Icon type="phone" />
            </IconContainer>
          ) : (
            <IconContainer>
              <div>{icon}</div>
            </IconContainer>
          )
        ) : null}
      </InputGroupFlex>
      <div style={{display:'flex', alignItems: 'center', columnGap: "1rem" }}>
        <input
          type="checkbox"
          checked={updatedObject && updatedObject["unknownDollarValue"] ? updatedObject["unknownDollarValue"] : false}
          name={"unknownDollarValue"}
          onChange={onChange}
          style={{ width: "16px", height: "16px", cursor: "pointer" }}
        />
          Dollar Value Unknown
      </div>
    </>
  );
}

function UpdateCreditModalNew({ show, close, fields, updateRow,modalTitle, handleTaxCreditUpdatedInfo, updatedObject }) {
  const { styles } = defaultStyles;

  const handleUpdate = () => {
    updateRow();
    close();
  };

  const value = {
    icon: "$",
    iconPosition: "start",
    value: updatedObject["amountOfCredit"],
    placeholder: 'Enter value..',
    name: "amountOfCredit",
    updatedObject,
    onChange: (event) => handleTaxCreditUpdatedInfo(event.target),
  }
  
  return (
    <Modal show={show} customWidth={true}>
      <Style.HeaderConatinerNew>
        <Text style={styles.text.formHeaderText}>{modalTitle}</Text>
        <Icon type="close" onClick={close}></Icon>
      </Style.HeaderConatinerNew>

      <Style.FieldsContainer  style={{height:'20rem'}}>
        <InputGroup style={{width:"15rem",marginTop:'0px'}}>
            <Text style={styles.text.labelText} padding="1rem 0 0rem 0 ">
              Amount Of Credit
            </Text>
          <IconInputTaxNew 
            value={value}
          />
        </InputGroup>
        {fields &&
          fields.map((data, index) => {
            const { value, Component, title, name, onChange,style } = data;
            return (
              <InputGroup style={{width: "15rem",
                    marginTop: "0px",
                    ...(value && value.name === "taxCredit" ? { marginBottom: "2rem" } : {})}}>
                <Text style={styles.text.labelText} padding="1rem 0 0rem 0 ">
                  {title || value.title}
                </Text>

                <Component
                  key={index}
                  value={value}
                  name={name}
                  onChange={onChange}
                  style={style}
                  type={ data && data.type ? data.type : ""}
                />
              </InputGroup>
            );
          })}
      </Style.FieldsContainer>

      <Style.ButtonsContainer>
        <Button style={styles.button.smallButton} onClick={close}>
          Cancel
        </Button>
        <Button style={styles.button.smallButton} onClick={handleUpdate}>
          Update
        </Button>
      </Style.ButtonsContainer>
    </Modal>
  );
}

export default UpdateCreditModalNew;
